import * as HttpService from './http.service';
import * as URL from './url.service';

export const createUserPreference = (data) => HttpService.postWithAuth(URL.USER_PREFERENCE(), data);
export const getUserPreference = () => HttpService.getWithAuth(URL.USER_PREFERENCE());
